module.exports = __webpack_public_path__ + "img/1.d81a4db8.png";